import groq from 'groq';

import { ASSET_DECORATIVE, RICH_TEXT, STUDY_MODAL } from '../common';

export const BENEFIT_CARDS = groq`
  eyebrow,
  title,
  description,
  disclaimer,
  cta {
    title,
    href
  },
  cards[] {
    _type,
    "variant": select(
      _type == "timeline_benefitChartCard" => "chart",
      _type == "timeline_benefitDefaultCard" => "default",
      _type == "timeline_benefitImageCard" => "image",
      _type == "timeline_benefitPictogramCard" => "pictogram"
    ),
    title,
    description[] {
      ${RICH_TEXT}
    },
    statistic,
    "modal": benefitModal->{
      ${STUDY_MODAL}
    },
    // ChartCard-specific fields
    _type == "timeline_benefitChartCard" => {
      isFullWidth
    },
    // ImageCard-specific fields
    _type == "timeline_benefitImageCard" => {
      "background": {
        "image": backgroundImage { ${ASSET_DECORATIVE} }
      }
    }
  }
`;

export const BENEFIT_CARDS_BLOCK = groq`
  _type == 'timeline_benefitCards' => @-> {
    ${BENEFIT_CARDS}
  }
`;
